var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-node",style:(`--grid-template-columns: ${_vm.gridTemplateColumns}; --grid-gap: ${_vm.gridGap}`)},_vm._l((_vm.content),function(item,i){return _c('form-node',_vm._g(_vm._b({key:i},'form-node',item,false),_vm.$listeners))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }